import * as React from 'react'

export function TwemojiFlagJapan(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" width="1em" height="1em" viewBox="0 0 36 36" {...props}>
      <path
        fill="#EEE"
        stroke="#CCCCCC"
        strokeWidth="1"
        d="M36 27a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V9a4 4 0 0 1 4-4h28a4 4 0 0 1 4 4v18z"
      />
      <circle fill="#BC002D" cx="18" cy="18" r="7" />
    </svg>
  )
}
